import '../styles/CtaSection.css';

export default function CtaSection() {
  return (
    <section className="cta-section">
      <div className="cta-inner">
        <p className="cta-heading">Explore the onchain UX ecosystem</p>
        <p className="cta-heading" style={{ fontWeight: 400 }}>
          Learn more about the Dev Mainnet Network and how to become
          part of its thriving community.
        </p>
      </div>
    </section>
  );
}